import React from "react";
import { usePermission } from "@/hooks/usePermission";

/**
 * Render children only when the current user can perform (resource, action).
 * Optionally show a fallback (defaults to null).
 */
export function RoleGate({ resource, action = "read", fallback = null, children }) {
    const { can } = usePermission();
    return can(resource, action) ? children : fallback;
}
